import React from "react";
import "./Reviews.css";

function Reviews() {
  const reviews = [
    {
      id: 1,
      name: "Bryan Rene Pallo Farinango",
      rating: 5,
      text: "Excelente producto, justo lo que necesitaba. Compré estos separadores de dedos y quedé muy satisfecho con mi compra. El producto es exactamente como se describe en la publicación. La calidad del material es excelente: resistente pero al mismo tiempo suave y cómodo de usar. Se ajustan bien y no causan molestias incluso después de un uso prolongado. Además, llegaron bien empaquetados y en perfecto estado. Desde el primer uso noté una gran diferencia en la comodidad de mis pies. Sin duda, es un artículo que recomendaría a cualquier persona que necesite algo similar. Muy contento con la compra y con el servicio recibido. ¡Cinco estrellas bien merecidas!",
      date: "9 de diciembre de 2024",
      url: "https://www.amazon.es/gp/customer-reviews/R35QIONXER90U9/ref=cm_cr_dp_d_rvw_ttl?ie=UTF8",
    },
    {
      id: 2,
      name: "Eduardo",
      rating: 4,
      text: "Perfectas para los dolores y además para los que están dispuestos [sic] de callos o juanete lo recomiendo.",
      date: "9 de marzo de 2026",
      url: "https://www.amazon.es/s?srs=67931308031&rh=p_89%3ASUPLYMAR",
    },
    {
      id: 3,
      name: "Raul Vilchez",
      rating: 5,
      text: "Muy cómodas. Generan compresión que viene bien para el codo de tenista. Además la pieza acolchada está bien colocada y evita toques con los huesos prominentes del codo.",
      date: "10 de julio de 2025",
      url: "https://www.amazon.es/s?srs=67931308031&rh=p_89%3ASUPLYMAR",
    },
    {
      id: 4,
      name: "Svetlana lonzana",
      rating: 5,
      text: "Cela n’est pas la première ceinture que j’ai acheté. Je l’ai commandé car les autres ont commencé être usées. J’ai été satisfaite avec les autres aussi mais celle là elle est géniale. Grâce à deux barres rigides à l’intérieur elle donne soutient et stabilité magnifique. Et en plus pour tel prix! Avec le temps y uso si hace falta la ciertamente recachèterais.",
      date: "29 de septiembre de 2024",
      url: "https://www.amazon.es/s?srs=67931308031&rh=p_89%3ASUPLYMAR",
    },
    {
      id: 5,
      name: "Cliente Amazon",
      rating: 5,
      text: "La verdad que la faja, al menos para mi, es genial. Sujeta muy bien y se la ve robusta, no de estas que te las pones dos veces y las tienes que tirar.",
      date: "9 de octubre de 2026",
      url: "https://www.amazon.es/s?srs=67931308031&rh=p_89%3ASUPLYMAR",
    },
  ];

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <span key={i} className={i < rating ? "star filled" : "star"}>
        ★
      </span>
    ));
  };

  return (
    <section className="reviews">
      <div className="reviews-container">
        <h2>Lo que dicen nuestros clientes</h2>
        <p className="reviews-subtitle">Reseñas verificadas de Amazon</p>
        <div className="reviews-grid">
          {reviews.map((review) => (
            <a
              key={review.id}
              className="review-card"
              href={review.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="review-header">
                <div className="review-rating">
                  {renderStars(review.rating)}
                </div>
                <span className="review-date">{review.date}</span>
              </div>
              <p className="review-text">"{review.text}"</p>
              <p className="review-author">- {review.name}</p>
            </a>
          ))}
        </div>
        <div className="amazon-link">
          <a
            href="https://www.amazon.es/s?srs=67931308031&rh=p_89%3ASUPLYMAR"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ver todas las reseñas en Amazon →
          </a>
        </div>
      </div>
    </section>
  );
}

export default Reviews;
